import React from "react";
import moment from 'moment';
import { fdate, roundInt, roundFloat } from './helpers';
import { FRONT_DF_1 } from '../CONST';


export const headerOperation = (instance) => (
  <div className="text-center table-header">
    {instance}
  </div>
);

export const headerDoubleRowOperation = (instance1, instance2) => (
  headerOperation((
    <>
      <div>{instance1}</div>
      <div>{instance2}</div>
    </>
  ))
);

export const determineMovementStatus = (movimientos) => {
  if (!movimientos || movimientos.length === 0) return [];

  // Verificar si hay movimientos pendientes
  const movimientosPendientes = movimientos.filter(
    (movimiento) => movimiento.estado_data.nemotecnico === "pendiente"
  );

  // Si hay movimientos pendientes
  if (movimientosPendientes.length > 0) {
    // Encontrar el último movimiento que no esté pendiente
    const ultimoMovimientoAnterior = movimientos.find(
      (movimiento) => movimiento.estado_data.nemotecnico !== "pendiente"
    );

    return movimientos.map((movimiento) => {
      if (movimiento.estado_data.nemotecnico === "pendiente") {
        // Los movimientos pendientes tienen estado con "-"
        return {
          ...movimiento,
          status: "-"
        };
      } else if (ultimoMovimientoAnterior && movimiento.id === ultimoMovimientoAnterior.id) {
        // El último movimiento anterior (no pendiente) sigue vigente
        return {
          ...movimiento,
          status: "Vigente"
        };
      } else {
        // Los demás son históricos
        return {
          ...movimiento,
          status: "Historica"
        };
      }
    });
  }

  // Si no hay movimientos pendientes, el primer movimiento es vigente
  const primerMovimiento = movimientos[0];
  return movimientos.map((movimiento) => ({
    ...movimiento,
    status: movimiento.id === primerMovimiento.id ? "Vigente" : "Historica",
  }));
};

export const cellStatus = (status) => (
  <div className="text-center table-cell wrap">
    {status}
  </div>
);

export const cellOperation = (instance, align = 'center', wrap = true) => (
  <div className={`text-${align} table-cell ${wrap ? 'wrap' : ''}`}>
    {(instance || instance === 0) ? instance : '-'}
  </div>
);

export const cellNumOperation = (instance, type, suffix = '') => { 
  if (type === 'float') {
    return cellOperation(instance && roundFloat(instance) + suffix,'right');
  }
  return cellOperation(instance && roundInt(instance) + suffix,'right');
};

export const cellNumOperationCenter = (instance, type, suffix = '') => { 
  if (type === 'float') {
    return cellOperation(instance && roundFloat(instance) + suffix,'center');
  }
  return cellOperation(instance && roundInt(instance) + suffix,'center');
};

export const cellNumOperationInt = (instance, suffix = '') => { 
  const value = instance ? roundInt(Number(instance)) : 0;
  return cellOperation(value + suffix, 'right');
};


export const cellDobleRowOperation = (row1, row2) => cellOperation((
  <>
    <div>{row1}</div>
    <div>{row2}</div>
  </>
), 'left');

export const cellDateOperation = (instance, format = FRONT_DF_1) => cellOperation(
  fdate(instance, format)
);

// todo: poner esta función en otro lado
export const renderPolicyIsVigente = balance => {
  if (balance) {
    if (balance.es_balance === false)
      return "No";
    const hoy = moment();
    const fin = moment(balance.termino_vigencia);
    return fin.isBefore(hoy, 'date') ? "No" : "Sí";
  }
  return "";
};

export const cellNumOperationIntCLPCase = (instance, suffix = '') => {
  const value = instance ? new Intl.NumberFormat('de-DE').format(Math.round(Number(instance))) : '0';
  return value;
};